function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import { RhfFieldError, rhfMapper, useController } from '@isyc-react/form/modules/rhf';
import { InputParameter } from "./input-parameter.component";
import { ParameterType } from '@isyc-react/types';
export const validParameter = (dataValue, data) => {
  // TODO apply decimal regex if not obligatory too ...
  if (!data.obligatory) return true;
  switch (data.parameterType) {
    case ParameterType.BOOLEAN_TYPE:
      return true;
    case ParameterType.DECIMAL_TYPE:
      // TODO check data.decimalFormat regex ?
      return true;
    default:
      return Boolean(dataValue);
  }
};
export const RhfInputParameter = props => {
  const {
    rhf,
    errorMessage,
    input,
    justify
  } = props;
  const {
    data
  } = input;
  const {
    field: {
      onChange,
      onBlur,
      name,
      value,
      ref
    },
    fieldState: {
      error
    }
  } = useController(rhfMapper(rhf, {
    valid: p => validParameter(p.value, data)
  }));
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(InputParameter, _extends({
    justify: justify,
    onChange: onChange,
    onBlur: onBlur,
    value: value,
    error: Boolean(error)
  }, input)), /*#__PURE__*/React.createElement(RhfFieldError, {
    errorMessage: errorMessage,
    error: error
  }));
};